import { render, staticRenderFns } from "./AuthorAnswerCard.vue?vue&type=template&id=71c00bac&scoped=true&"
import script from "./AuthorAnswerCard.vue?vue&type=script&lang=js&"
export * from "./AuthorAnswerCard.vue?vue&type=script&lang=js&"
import style0 from "./AuthorAnswerCard.vue?vue&type=style&index=0&id=71c00bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c00bac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VCard,VCardText,VDivider,VFlex,VLayout})
